import { combineReducers } from "redux";
import userMessage from "./userMessage";
import auth from "./auth";
import technicianTimesheet from "./technicianTimeSheet";
import monthData from "./monthData";
import userTechData from "./userTechData";
import modalPopup from "./modalPopup";
import saveTechnicianTimesheet from "./saveTechnicianTimeSheet";
import recalculateHour from "./recalculateHour";
import managerTimesheetData from "./managerTimesheetData";
import shiftUpdate from "./shiftUpdate";
import employeeOnboard from "./employeeOnboard";
import scheduleHours from "./scheduleHours";
import standBy from "./standBy";
import hourAnalytics from "./hourAnalytics";
import fetchTimesheetSecurity from "./fetchTimesheetSecurity";
import holidayManager from "./holidayManager";
import approveWeekData from "./approveWeekData";
import weekPlanner from "./weekPlanner";
import shiftWiseEmployees from "./shiftWiseEmployees";
import fetchStandByDetails from "./fetchStandByDetailsReducer"
const loadingReducer = (state = {}, action) => {
  const { type } = action;
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);

  // not a *_REQUEST / *_SUCCESS /  *_FAILURE actions, so we ignore them
  if (!matches) return state;

  const [, requestName, requestState] = matches;
  return {
    ...state,
    // Store whether a request is happening at the moment or not
    // e.g. will be true when receiving GET_TODOS_REQUEST
    //      and false when receiving GET_TODOS_SUCCESS / GET_TODOS_FAILURE
    [requestName]: requestState === "REQUEST"
  };
};

export default combineReducers({
  auth,
  loadingReducer,
  userMessage,
  technicianTimesheet,
  monthData,
  userTechData,
  modalPopup,
  saveTechnicianTimesheet,
  recalculateHour,
  managerTimesheetData,
  shiftUpdate,
  employeeOnboard,
  scheduleHours,
  standBy,
  hourAnalytics,
  fetchTimesheetSecurity,
  holidayManager,
  approveWeekData,
  weekPlanner,
  shiftWiseEmployees, fetchStandByDetails
});
